<template>
    <div>
      <b-dropdown variant="link" size="sm" dropup class="ml-2" no-caret >
        <template slot="button-content">
          <button id="add-new-ocurrence"
              >+</button>
        </template>
        <button class="item-droup" @click="popupcurrenceOpen">Novo Chamado <i class="fas fa-plus ml-1"></i></button>
        <b-modal
          centered
          size="lg"
          ref="popupcurrence-modal"
          id="popupcurrence-modal"
          title="Adicionar Novo Chamado"
          hide-footer
        >
        <div class="d-flex popupOcurrence">
          <div class="stepup">
              <stepocurrence :nivel="valuepogrress"/>
          </div>

          <div v-if="valuepogrress === 0" class="columnchamado">
            <div class="titulochamado">
              <label class="descricaochamado">Selecione a patologia:</label>
            </div>
            <div id="panel-chamado-0" class="divchamado" :class="{'divchamado-actived': Array.isArray(formnewoccourence.patologia) && formnewoccourence.patologia.includes(0)}" @click="setvalueProblem(0)">
              <button class="btn tipochamado">
                <img class="icon-chamado" src="https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Infiltracao.svg">
                <label class="descricaochamado">Infiltração</label>
              </button>
            </div>
            <div id="panel-chamado-1" class="divchamado" :class="{'divchamado-actived': Array.isArray(formnewoccourence.patologia) && formnewoccourence.patologia.includes(1)}" @click="setvalueProblem(1)">
              <button class="btn tipochamado">
                <img class="icon-chamado" src="https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Eletrico.svg">
                <label class="descricaochamado">Elétrico</label>
              </button>
            </div>
            <div id="panel-chamado-2" class="divchamado" :class="{'divchamado-actived': Array.isArray(formnewoccourence.patologia) && formnewoccourence.patologia.includes(2)}" @click="setvalueProblem(2)">
              <button class="btn tipochamado">
                <img class="icon-chamado" src="https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Pisos_Revestimento.svg">
                <label class="descricaochamado">Pisos e Revestimento</label>
              </button>
            </div>
            <div id="panel-chamado-3" class="divchamado" :class="{'divchamado-actived': Array.isArray(formnewoccourence.patologia) && formnewoccourence.patologia.includes(3)}" @click="setvalueProblem(3)">
              <button class="btn tipochamado">
                <img class="icon-chamado" src="https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Esquadrias.svg">
                <label class="descricaochamado">Esquadrias, Janelas e Portas</label>
              </button>
            </div>
            <div id="panel-chamado-4" class="divchamado" :class="{'divchamado-actived': Array.isArray(formnewoccourence.patologia) && formnewoccourence.patologia.includes(4)}" @click="setvalueProblem(4)">
              <button class="btn tipochamado">
                <img class="icon-chamado" src="https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Vedacao.svg">
                <label class="descricaochamado">Vedação Interna e Externa</label>
              </button>
            </div>
            <div id="panel-chamado-5" class="divchamado" :class="{'divchamado-actived': Array.isArray(formnewoccourence.patologia) && formnewoccourence.patologia.includes(5)}" @click="setvalueProblem(5)">
              <button class="btn tipochamado">
                <img class="icon-chamado" src="https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Pintura.svg">
                <label class="descricaochamado">Pintura</label>
              </button>
            </div>
            <div id="panel-chamado-6" class="divchamado" :class="{'divchamado-actived': Array.isArray(formnewoccourence.patologia) && formnewoccourence.patologia.includes(6)}" @click="setvalueProblem(6)">
              <button class="btn tipochamado">
                <img class="icon-chamado" src="https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Loucas.svg">
                <label class="descricaochamado">Louças e Metais</label>
              </button>
            </div>
            <div id="panel-chamado-7" class="divchamado" :class="{'divchamado-actived': Array.isArray(formnewoccourence.patologia) && formnewoccourence.patologia.includes(7)}" @click="setvalueProblem(7)">
              <button class="btn tipochamado">
                <img class="icon-chamado" src="https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Hidraulica.svg">
                <label class="descricaochamado">Hidráulica</label>
              </button>
            </div>
            <div id="panel-chamado-8" class="divchamado" :class="{'divchamado-actived': Array.isArray(formnewoccourence.patologia) && formnewoccourence.patologia.includes(8)}" @click="setvalueProblem(8)">
              <button class="btn tipochamado">
                <img class="icon-chamado" src="https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Tubulacoes.svg">
                <label class="descricaochamado">Tubulações</label>
              </button>
            </div>
            <div id="panel-chamado-9" class="divchamado" :class="{'divchamado-actived': Array.isArray(formnewoccourence.patologia) && formnewoccourence.patologia.includes(9)}" @click="setvalueProblem(9)">
              <button class="btn tipochamado">
                <img class="icon-chamado" src="https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Estrutura.svg">
                <label class="descricaochamado">Estruturas</label>
              </button>
            </div>
            <div id="panel-chamado-10" class="divchamado" :class="{'divchamado-actived': Array.isArray(formnewoccourence.patologia) && formnewoccourence.patologia.includes(10)}" @click="setvalueProblem(10)">
              <button class="btn tipochamado">
                <img class="icon-chamado" src="https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Impermeabilizacao.svg">
                <label class="descricaochamado">Impermeabilização</label>
              </button>
            </div>
            <div id="panel-chamado-11" class="divchamado" :class="{'divchamado-actived': Array.isArray(formnewoccourence.patologia) && formnewoccourence.patologia.includes(11)}" @click="setvalueProblem(11)">
              <button class="btn tipochamado">
                <img class="icon-chamado" src="https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Outros.svg">
                <label class="descricaochamado">Outros</label>
              </button>
            </div>
          </div>

        <div v-if="valuepogrress === 1" class="d-flex" style="max-height:500px">
          <template>
          <div id="card-details">
              <div id="title">
            <div class="line1">
                <div class="text-left1" id="inf-mor"> Descreva o problema informado pelo Morador</div>
                <!-- <button class="btnfaqchamado"><img  src="/static/img/realestate/BotãoFAQ.png"></button> -->
                <!-- <button class="btnfaqchamado"><img src="/static/img/realestate/BotãoFAQ.png"></button> -->
            </div>
            <div class="editordiv">
              <!-- <VueEditor v-model="testeee" :editorToolbar="customToolbar" class="editorSize"></VueEditor> -->
              <textarea class="form-control mt-3" rows="10" cols="175" v-model="formnewoccourence.descricao"></textarea>
            </div>
          </div>
        </div>
        </template>
      </div>
      <div v-if="valuepogrress === 2" class="w-100">
            <div id="title">
              <p class="dadomorador"> Preencha os dados do morador</p>
            </div>
            <div class="formulario mt-3">
              <div class="grid-formulario-two">
                <div>
                  <label class="label-form" style="width: 100%;" >Nome do Morador:</label>
                  <input v-model="formnewoccourence.nomemorador" class="form-control">
                </div>
                <div>
                  <label class="label-form" style="width: 100%;" >E-mail:</label>
                  <input v-model="formnewoccourence.email" type="email" class="form-control">
                </div>
              </div>
              <div class="grid-formulario">
                <div>
                  <label class="label-form" >Celular:</label>
                  <input v-model="formnewoccourence.celular" class="form-control" v-mask="['(##) #####-####']" />
                </div>
                <div>
                  <label class="label-form" >Telefone:</label>
                  <input  v-model="formnewoccourence.telefone" class="form-control" v-mask="['(##) ####-####']"/>
                </div>
                <div>
                  <label class="label-form" >CPF:</label>
                  <input  v-model="formnewoccourence.cpf" class="form-control" v-mask="['###.###.###-##']"/>
                </div>
              </div>
              <div class="grid-formulario">
                <div style="width: 65%;">
                  <label class="label-form" >Empreendimento:</label>

                  <!-- <select :disabled="formnewoccourence.cpf === null" v-model="formnewoccourence.EmpreendimentoNovaUnidadeId" class="form-control"> -->
                  <select v-model="formnewoccourence.EmpreendimentoNovaUnidadeId" class="form-control">
                    <option disabled selected :value="''">Selecione o empreendimento</option>
                    <option v-for="(data) in dataAllenterpriseNewUnit" :key="data.id" :value="data.id">{{data.nomeUnidade}}</option>
                  </select>
                </div>
                <div style="width: 35%;">
                  <label class="label-form" >Unidade:</label>
                  <input v-model="formnewoccourence.nomeUnidade" type="text" class="form-control">
                </div>
              </div>
            </div>
          </div>
           <div v-if="valuepogrress === 3" class="w-100">
              <div id="title">
                <p class="dadomorador-final"> Dados do Morador</p>
              </div>
              <div class="briefingOcurrence">
                <div class="d-flex flex-wrap">
                  <div class="grid-resumo">
                    <div>
                      <label class="label-final">Morador</label>
                      <p>{{formnewoccourence.nomemorador}}</p>
                    </div>
                    <div>
                      <label class="label-final">Email</label>
                      <p>{{formnewoccourence.email}}</p>
                    </div>
                  </div>
                  <div class="grid-resumo">
                    <div style="width: 100%;">
                      <label class="label-final">CPF</label>
                      <p>{{formnewoccourence.cpf}}</p>
                    </div>
                    <div style="width: 100%;">
                      <label class="label-final">Celular</label>
                      <p>{{formnewoccourence.celular}}</p>
                    </div>
                    <div style="width: 100%;">
                      <label class="label-final">Telefone</label>
                      <p>{{formnewoccourence.telefone}}</p>
                    </div>
                  </div>
                  <div class="grid-resumo">
                    <div>
                      <label class="label-final">Empreendimento</label>
                      <p>{{getEmpreendimentoId(formnewoccourence.EmpreendimentoNovaUnidadeId)}}</p>
                    </div>
                    <div>
                      <label class="label-final">Unidade</label>
                      <p>{{formnewoccourence.nomeUnidade}}</p>
                    </div>
                  </div>
              </div>
              <!-- <div class="grid-resumo">
                <div>
                  <label class="label-final">Empreendimento</label>
                  <p>{{getEmpreendimentoId(formnewoccourence.EmpreendimentoNovaUnidadeId)}}</p>
                </div>
                <div>
                  <label class="label-final">Unidade</label>
                  <p>{{formnewoccourence.nomeUnidade}}</p>
                </div>
              </div> -->
            </div>
            <hr>
            <div id="title">
              <p class="dadomorador-final"> Informações do Chamado</p>
            </div>

            <label class="label-final">Patologias</label>
            <div class="grid-resumo">

              <div v-if="formnewoccourence.patologia && formnewoccourence.patologia.length > 0" class="lista-patologias">
                <div
                  v-for="(patologiaId, index) in formnewoccourence.patologia"
                  :key="index"
                  class="container-details-info"
                >
                  <div class="icone-details">
                    <img :src="iconselector(patologiaId)" alt="Ícone do problema" />
                  </div>
                  <p class="text-details-info">{{ getproblemaraiz(patologiaId) }}</p>
                </div>
              </div>

              <p v-else class="text-details-info">Nenhuma patologia selecionado.</p>
            </div>

           </div>
      </div>
      <div class="buttonocurrence">
          <button v-if="valuepogrress > 0" type="button" class="btn btn-secondary" @click="backPopupPages" :disabled="valuepogrress == 0"><b>Voltar</b></button>
          <button v-else type="button" class="btn btn-secondary" @click="closeModal"><b>Fechar</b></button>
          <button type="button" class="btn btn-third" @click="nextPopupPages"><b> Avançar</b></button>
        </div>
      </b-modal>
    </b-dropdown>
  </div>
</template>

<script>
import addocurrence from './addocurrence.js'
export default addocurrence
</script>
<style scoped>
.lista-patologias {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

#add-new-ocurrence{
    font-size: 28px;
    background-color: #008144;
    outline: transparent;
    color:white;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    border:transparent
}
.p_Name{
    font: normal normal normal 16px/21px Segoe UI;
    color: #2A2A2A;
    text-align: left;
    margin: 0;
}

.text-details-info{
  font-size: 15px;
  margin-top: 10px;
  font-weight: bold;
  color: #008148;
}
.label-final{
  padding: 0.5rem;
  font: normal normal 600 14px/24px Segoe UI;
  line-height: 0px;
  font-weight: bold;
}
.container-details-info {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 6px 10px;
  background: #fafafa;
}

.icone-details{
  width: 24px;
  padding: 5px;
  height: 24px;
  background: #F2F2F2;
  display: flex;
  justify-content: center;
  font-size: 35px;
  align-items: center;
  color: #2E973D;
  border-radius: 50%;
}
.input-modal-novo-tecnico{
  width: 100%;
  padding-right: 20px;
  padding-left: 20px;
  padding-top: 5px;
}

.container-cancela-cadastra-modal {
  margin-left: 1.2rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  grid-auto-columns: 1fr;
  gap: 0px 0px;
  grid-auto-flow: row;
  grid-template-areas:
    "cancela cadastra";
}

.cancela {
    grid-area: cancela;
    display: flex;
    justify-content: center;
    /* width: 140px; */
 }

.cadastra {
    grid-area: cadastra;
    display: flex;
    justify-content: center;
}

.button-modal-novo-tecnico{
    width: 60%;
    height: 40px;
    border-radius: 10px;
    font: normal normal 600 14px/24px Segoe UI;
    margin-top: 1.6rem;
}

.input-zopone{
  accent-color: #008148;
}
.dadomorador{
  font-size: 16px;
  line-height: 0px;
  font-weight: bold;
  margin-top: 1rem;
  font-family: 'Segoe UI';
  color: #008148;
}
.dadomorador-final{
  font-size: 16px;
  line-height: 0px;
  font-weight: bold;
  margin-top: 1rem;
  font-family: 'Segoe UI';
  color: #008148;
  display: flex;
}

.slide-meses {
   height: 100px;
}
.body-calenders{
  margin-top: 15px;
  display: flex;
  padding: 15px;
  border-radius: 10px;
  width: 100%;
  background: #DFDFDF;
}

.vdp-datepicker{
  width: initial;
}
.vdp-datepicker__calendar .cell.selected{
  background: #008144 !important;
}
.day__month_btn{
  background: #008144 !important;
}

.carousel-item{
  color: #fafafa;
}
.grid-resumo{
  display: flex;
  width: 100%;
  gap: 1rem;
  font-family: 'Segoe UI';
  font-size: 16px;
}
.carousel {
  height: 40px;
  position: relative;
}

.month {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-weight: bold;
  font-size: 1.2rem;
}

.carousel-control-prev,
.carousel-control-next {
  width: 5%;
  background: none;
  margin-left: 200px;
  margin-right: 200px;
  margin-bottom: 6px;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  height: 60%;
  width: 100%;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.1);
}
.nmd{
  margin-top: 8px;
}
.carousel-control-prev-icon {
  left: 0;
}

.carousel-control-next-icon {
  right: 0;
}

.grid-formulario{
  margin-top: 3%;
  display: flex;
  gap: 15px;
  /* grid-template-columns: 1fr 1fr 1fr; */
}
.grid-formulario-two{
  width: 100%;
  margin-top: 3%;
  display: grid;
  gap: 15px;
   grid-template-columns: 1fr 1fr ;
}
.label-form{
  line-height: 0px;
  font-weight: bold;
  font-family: 'Segoe UI';
}

.morador { grid-area: 1 / 1 / 2 / 3; }

.emailp { grid-area: 1 / 3 / 2 / 4; }

.cel { grid-area: 2 / 1 / 3 / 2; }

.tel { grid-area: 2 / 2 / 3 / 3; }

.cpfp { grid-area: 2 / 3 / 3 / 4; }

.emp { grid-area: 3 / 1 / 4 / 2; }

.apto { grid-area: 3 / 2 / 4 / 3; }

.garan { grid-area: 3 / 3 / 4 / 4; }

.usuario-s { grid-area: 1 / 1 / 2 / 3; }

.email { grid-area: 1 / 3 / 2 / 4; }

.celu { grid-area: 2 / 1 / 3 / 2; }

.telef { grid-area: 2 / 2 / 3 / 3; }

.cpfinp { grid-area: 2 / 3 / 3 / 4; }

.empree { grid-area: 3 / 1 / 4 / 2; }

.apart { grid-area: 3 / 2 / 4 / 3; }

.garant { grid-area: 3 / 3 / 4 / 4; }

.garan {
   height: 25px;
   width: 25px;
   background-color: green;
   }
.line1{
  display: flex;
}
/* .editorSize{
    height: 200px;
    width: 300px;
    font: normal normal normal 18px/24px Segoe UI;
} */
/* .editordiv{
  height: 250px;
  width: 300px;
} */
.btn-secondary{
  background-color:#DEDEDE;
  color:#747474;
  border-radius: 4px;
  opacity: 1;
  width: 15rem;
}

.btn-third{
  background: #008148;
  border-radius: 4px;
  opacity: 1;
  width: 15rem;
}

.btn-third2{
    background: #008148;
    border-radius: 4px;
    opacity: 1;
    width: 15rem;
    color: white;
}

.btnfaqchamado{
  /* width: 30%; */
  /* padding-left: 110%; */
  background-color: #fafafa;
  /* width: 10%; */
  border: none;
}

.editorSize{
  /* height: 250px; */
  width: 600px;
  padding-top: 3%;
}
.text-left1{
  font-size: 14px;
  padding-top: 1%;
  font-family: 'Segoe UI';
  font-weight: bold;
  color: #008148;
}

.descricaochamado{
  color: #1C6228;
  font-size: 15px;
  font-weight: bold;
}

.tipochamado {
  background-color: #fafafa;
  border: none;
  border-radius: 15px;
  width: 125px;       /* largura fixa */
  height: 125px;       /* altura fixa */
  display: grid;
  grid-template-rows: 1fr 1fr;
  justify-content: center;
  align-items: center;
  margin: 1px;
  cursor: pointer;    /* deixa o cursor de botão */
  transition: background-color 0.3s ease; /* efeito suave */
}

.tipochamado:hover {
  background-color: #e0e0e0; /* efeito hover opcional */
}

.buttonocurrence{
  text-align: center;
  display: flex;
    justify-content: center;
    gap: 3rem;
}

.PopupChamado{
  width: 80rem !important;
}

.divchamado{
  display: grid;
}
.stepup{
  width: 15rem;
  display: grid;
}

.columnchamado{
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 25px 1fr 1fr 1fr;
  align-items: center;
  justify-items: center;
  gap: 0.5rem;
  width: 100%;
  font-family: 'Segoe UI';
 }
.titulochamado{
  font-size: 18px;
  color:#707070;
  grid-area: 1/1/1/5;
  justify-self: start;
}

.icon-chamado{
  max-width: 40px;
  max-height: 40px;
  justify-self: center;
}

.item-droup{
  width: 100%;
  border-radius: 10px;
  border: none;
  height: 35px;
  font-size: 16px;
  font-weight: bold;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Segoe UI';
  color: #666666
}
#add-ocurrence-modal{
  width: 150px;
  height: 30px;
  border-radius: 50px;
  position: fixed;
  bottom: 125px;
  right: 10px;
}
.containercaled{
  background-color: #707070;
}
.weekday, .day {
  text-align: center;
  padding: 10px;
  border: 1px solid #ccc;
}

.weekday {
  font-weight: bold;
}

.day {
  cursor: pointer;
}

.day.text-muted {
  background-color: #eee;
}

.day.bg-primary.text-white {
  background-color: #2196f3;
  color: white;
}
.modal-body{
    display: grid !important;
    grid-template-columns: 30% 70% !important;
}
.divchamado-actived{
  border: 2px solid #008148;
  border-radius: 10px;
  outline: none;
}

.popupOcurrence {
  gap: 1.5rem;
  margin-bottom: 3rem;
}

.briefingOcurrence {
    display: flex;
  }

.formulario{
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
}
@media (max-width: 1440px) {
  .briefingOcurrence {
    display: flex;
    flex-wrap: wrap;
  }

  .popupOcurrence {
    gap: 1.5rem;
    margin-bottom: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/ocurrence/components/addocurrence/addocurrence.vue